import { createAction, props } from '@ngrx/store';
import { QueryParams } from '../../models/states/query-params-state.interfaces';

enum QueryParamsActionTypes {
  storeQueryParamsInputValues = '[flight-shop book widget] store query params input params'
}

export const StoreQueryParamsInputValues = createAction(
  QueryParamsActionTypes.storeQueryParamsInputValues,
  props<{ queryParams: QueryParams | null }>()
);
